export const Logo = ({ className = "" }) => {
  return (
    <div className={`flex items-center ${className}`}>
      <img 
        src="/logo.svg" 
        alt="wirkaufendeinLaptop.de Logo" 
        className="h-12 md:h-16 w-auto"
        style={{ maxWidth: '420px' }}
      />
    </div>
  );
};
